/**
 * Create ProductDetailAttr context for custom hook
 */
import { createContext } from 'react'

const ProductDetailAttrContext = createContext({
  fetchProductDetailAttributeOptions: () => {},
  productDetailAttrReady: false,
  productDetailAttributeOptions: []
})

export default ProductDetailAttrContext
